import { schema } from 'normalizr';

const workoutSetExerciseSchema = new schema.Entity(
    'setExercises',
    {},
    {
        idAttribute: entity => entity.id
    }
);

export default workoutSetExerciseSchema;
